// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a525a69f","11":"5359ac7c","256":"b424f058","453":"4703e7bb","575":"a5df207e"}[chunkId] + ".chunk.js";
};